import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Thin dialog wrapper hosting the shared Test Clock form. Closes the instant a
 * Set or Clear succeeds (via the form's `done` output); Cancel is a no-op close.
 */
@Component({
    selector: 'test-clock-modal',
    templateUrl: './test-clock-modal.component.html'
})
export class TestClockModalComponent {
    constructor(public dialogRef: MatDialogRef<TestClockModalComponent>) {}
}
